import { Star, MoveLeft } from "lucide-react";

const PILL = {
  g: "bg-emerald-50 text-emerald-700 ring-1 ring-emerald-100",
  a: "bg-amber-50 text-amber-700 ring-1 ring-amber-100",
  r: "bg-rose-50 text-rose-600 ring-1 ring-rose-100",
  n: "bg-slate-100 text-slate-600 ring-1 ring-slate-200",
};

export function Pill({ t, c }) {
  return (
    <span className={`inline-flex items-center rounded-md px-2.5 py-1 text-[13px] font-semibold ${PILL[c] || PILL.n}`}>
      {t}
    </span>
  );
}

export function StarRow({ n = 0, size = 14 }) {
  return (
    <span className="flex items-center">
      {[0, 1, 2, 3, 4].map((i) => (
        <Star
          key={i}
          size={size}
          className={i < n ? "fill-amber-400 text-amber-400" : "fill-slate-200 text-slate-200"}
        />
      ))}
    </span>
  );
}

export function CompareTable({ columns, rows, overall }) {
  return (
    <div className="overflow-x-auto rounded-2xl border border-slate-200">
      <table className="w-full min-w-[820px] border-collapse text-center">
        <thead>
          <tr className="bg-[var(--navy)] text-white">
            <th className="sticky left-0 z-10 bg-[var(--navy)] px-5 py-4 text-left text-[13px] font-semibold">
              Category
              <span className="mt-1 flex items-center gap-1.5 text-[11px] font-medium text-slate-300">
                <MoveLeft size={13} className="animate-pulse" />
                Swipe to compare
              </span>
            </th>
            {columns.map((col, i) => (
              <th key={i} className="px-5 py-4 text-[13px] font-bold">
                {col.title}
                <span className="block text-[11px] font-normal text-slate-300">{col.sub}</span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, r) => (
            <tr key={r} className="border-t border-slate-100">
              <td className="sticky left-0 z-10 bg-white px-5 py-3.5 text-left text-[14px] font-medium text-[var(--ink)]">
                {row.c}
              </td>
              {row.v.map((cell, c) => (
                <td key={c} className="px-5 py-3.5">
                  <Pill t={cell.t} c={cell.c} />
                </td>
              ))}
            </tr>
          ))}
          {overall && (
            <tr className="border-t border-slate-100">
              <td className="sticky left-0 z-10 bg-white px-5 py-3.5 text-left text-[14px] font-medium text-[var(--ink)]">
                Overall Rating
              </td>
              {overall.map((n, i) => (
                <td key={i} className="px-5 py-3.5">
                  <span className="flex justify-center"><StarRow n={n} size={15} /></span>
                </td>
              ))}
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
